import { isMobile, PopoverV2 } from '@kizi/comparator-components';
import { Div, P } from '@kizi/core-components';
import React, { useState } from 'react';
import { SpeedPopup } from '../../SpeedPopup';
import { Window } from '@kizi/comparator-components';
import { IconV2 } from '@kizi/shared-components';

function getDisplayedScore(score: string) {
  return score &&
    score !== 'undefined' &&
    score !== '0,0' &&
    score !== '0.0' &&
    score !== '0'
    ? score.replace('.', ',')
    : '-,-';
}

export const InternetAndChannels = ({
  data,
  productTypes,
  containerStyles = {},
  openTab,
  itemsStyles = {
    speed: {},
    tv: {},
    score: {},
  },
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const getTestScoreValue = () => {
    const defaultValue = '0,0';

    const scores = data?.scoreEntity?.scores ?? [];

    return (
      scores.find((entity) => entity.name === 'Testoordeel')?.rating ||
      defaultValue
    );
  };

  const testScoreValue = getTestScoreValue();

  let displayScore = testScoreValue;

  if (!testScoreValue || testScoreValue === '0.0') {
    displayScore = '-,-';
  }

  const downloadSpeedInMb =
    data.servicesWrapper?.networkInformation?.internetSpeed?.downloadSpeedInMb;

  const tvChannels =
    data.servicesWrapper?.televisionInfo?.channels?.numberOfTvChannels;

  const hdChannels =
    data.servicesWrapper?.televisionInfo?.channels?.numberOfHdChannels;

  const DownLoadComponent = (
    <Div css={{ cursor: 'pointer' }}>
      <Div
        css={{
          borderBottom: '1px dashed rgba(0, 77, 245, 0.3)',
          display: 'flex',
          gap: '4px',
          alignItems: 'center',
        }}
      >
        <P
          variant="bodyImportant"
          css={{
            fontSize: '20px',
            lineHeight: '20px',
          }}
        >
          {downloadSpeedInMb}
        </P>
        <P
          variant="regularV2"
          css={{
            lineHeight: '21px',
          }}
        >
          {' Mbit/s'}
        </P>
      </Div>

      <P
        variant="captionRegular"
        css={{
          color: '#9B9B9B',
          lineHeight: '10px',
          fontSize: '10px',
          mt: '2px',
        }}
      >
        Download
      </P>
    </Div>
  );

  const isMobileDevice = isMobile();

  return (
    <Div
      css={{
        display: 'flex',
        flexDirection: ['row', 'row', 'column'],
        justifyContent: ['space-between', 'space-between', 'unset'],
        alignItems: ['center', 'center', 'flex-start'],
        ...containerStyles,
      }}
    >
      {productTypes?.includes('internet') && (
        <>
          {isMobileDevice ? (
            <Div
              onClick={() => {
                setIsOpen(true);
              }}
              css={{
                ...itemsStyles.speed,
              }}
            >
              {DownLoadComponent}
              <Window
                onClose={(e) => {
                  e.stopPropagation();
                  setIsOpen(false);
                }}
                show={isOpen}
              >
                <SpeedPopup data={data} />
              </Window>
            </Div>
          ) : (
            <PopoverV2
              content={<SpeedPopup data={data} />}
              placement={'top'}
              trigger="click"
              containerStyles={{ width: '340px', ...itemsStyles.speed }}
            >
              {DownLoadComponent}
            </PopoverV2>
          )}
        </>
      )}

      {productTypes?.includes('television') && tvChannels && (
        <Div mt={isMobileDevice ? 0 : '6px'} css={{ ...itemsStyles.tv }}>
          <Div
            width="max-content"
            css={{
              display: 'flex',
              gap: '4px',
              alignItems: 'center',
            }}
          >
            <P
              variant="bodyImportant"
              css={{
                fontSize: '20px',
                lineHeight: '20px',
              }}
            >
              {tvChannels}
            </P>
            {hdChannels && (
              <P variant="footnoteRegular">{`(${hdChannels} HD)`}</P>
            )}
          </Div>
          <P
            variant="captionRegular"
            css={{
              color: '#9B9B9B',
              lineHeight: '10px',
              fontSize: '10px',
              mt: '2px',
            }}
          >
            TV zenders
          </P>
        </Div>
      )}

      {/* Testscore */}
      <Div
        css={{
          borderRadius: '5px',
          padding: '10px',
          backgroundColor: '#F2F2F0',
          mt: isMobileDevice ? 0 : '20px',
          cursor: 'pointer',
          ...itemsStyles.score,
        }}
        onClick={() => openTab(0)}
      >
        <Div
          css={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <IconV2
            name={'favicon'}
            css={{
              flexShrink: 0,
              height: '20px',
              marginLeft: '-3px',
            }}
          />
          <P
            variant="bodyV2"
            css={{
              fontWeight: 700,
              fontSize: '20px',
            }}
          >
            {getDisplayedScore(displayScore)}
          </P>
        </Div>
        <P
          variant="bodyRegular"
          css={{
            fontSize: '8px',
            lineHeight: '11px',
            fontWeight: 700,
            textAlign: 'center',
            mt: '5px',
          }}
        >
          TESTOORDEEL
        </P>
      </Div>
    </Div>
  );
};
